import MULTICALL_ABI from './abi.json'
import { ChainId } from '../chain'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x59bfec593FE09F3f46EB328c82fcd19ABfc4b91F'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
